import __request__ from 'routing/request';
interface QuotaStatusResponse {
    readonly limit: number;
    readonly used: number;
    readonly reset_at: string;
    readonly remaining: number;
}
/**
 * Provides details about quota status related to AI-related calls
 */
export function quotaStatus(): Promise<QuotaStatusResponse> {
    return __request__('GET', '/plugins/org.graylog.plugins.aiservice/ai/quota', null, {}, {
        'Accept': ['application/json']
    });
}
